import { observable, action } from 'mobx';
import agent from '../services/web/agent';
import authenticationProvidersStore from './authenticationProvidersStore';
import formatAuthenticationProvider from '../services/formatters/authenticationProviderFormatter';
import oidcStore from './oidcStore';
import rolesStore from './roles/index';
class UsersStore {

    @observable users;
    @observable loadingUser;
    @observable loadingUsers;
    @observable deletingUser;

    @observable deletingUserErrorMessage;

    @action getAllUsers() {

        this.loadingUsers = true;

        return agent.Users.getAllUsers()
            .then(action((users) => {
                
                return authenticationProvidersStore.getAllAuthenticationProviders()
                .then(action((providers) => {
                    
                    for (let i = 0; i < users.length; i++) {
                    
                        users[i] = users[i];
                        users[i].fullName = users[i].firstName + ' ' + users[i].lastName;
                        let provider = providers.filter(p => p.id == users[i].authenticationProviderId)[0];
                        users[i].authenticationProvider = formatAuthenticationProvider(provider);
                        users[i].authenticationProviderType = provider.providerType;
                    }
                    
                    this.users = users;
                }));
            }))
            .finally(action(() => { 
                
                this.loadingUsers = false;
            }));
    }   

    @action getUser(userId) {
        
        this.loadingUser = true;

        return agent.Users.getUser(userId)
            .then(action((user) => {
                
                return user;
            }))
            .finally(action(() => { 
                
                this.loadingUser = false;
            }));
    }

    @action deleteUser(userId) {

        this.deletingUser = true;

        return agent.Users.deleteUser(userId)
            .then(action((user) => {
                this.deletingUser = false;
            }))
            .catch(action((err) => {

                if (err && err.response && err.response.text) {
    
                    this.deletingUserErrorMessage = JSON.parse(err.response.text).Message;
                }

                throw err;

            }))
            .finally(action(() => { 
                
                this.deletingUser = false;
            }));
    }

    isCurrentUserAdmin = async () => await this.isCurrentUserHaveRole('Admin');

    isCurrentUserHaveRole = async (role) => {
        const currentUserId = oidcStore.currentUser.profile.sub;
        let currenUser;
        if(this.users === undefined){
            currenUser = await this.getUser(currentUserId);
        }else{
            currenUser = this.users.filter(user => user.id == currentUserId)[0];
        }

        const roleId = await rolesStore.getRoleIdByName(role);
        return currenUser.roleIds.includes(roleId);
    }
}

export default new UsersStore();